import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core'
import { Subject } from'rxjs';
import * as Plyr from 'plyr';

@Injectable()
export class AudioPlayerService {
    private translatedTextLoaded = false;
    private audioPlayer: any;
    audioPromptPlayEvent = new Subject<void>();

    private translationTexts = {
        FORWARD: 'SHARED.AUDIO_PROMPT.FORWARD_BUTTON',
        REWIND: 'SHARED.AUDIO_PROMPT.REWIND_BUTTON',
        PLAY: 'SHARED.AUDIO_PROMPT.PLAY',
        PAUSE: 'SHARED.AUDIO_PROMPT.PAUSE',
        PROGRESS_BAR: 'SHARED.AUDIO_PROMPT.SCREEN_READER.PROGRESS_BAR'
    };

    constructor(
        private translationService: TranslateService
    ) {}  

    public async createPlayer(audioPlyrId, options, seekTime =  5) {
        if (!this.translatedTextLoaded) {
            const translationKeysToFetch = [];
            Object.keys(this.translationTexts).forEach(key => {
                translationKeysToFetch.push(this.translationTexts[key]);
            });
            const textsObject = await this.translationService.get(translationKeysToFetch).toPromise();
            Object.keys(this.translationTexts).forEach(key => {
                const translationKey = this.translationTexts[key];
                if (textsObject[translationKey]) {
                    this.translationTexts[key] = textsObject[translationKey];
                }
            });
            this.translatedTextLoaded = true;
        }
        const controls = ` 
            <div class="plyr__controls">
                ${this.getProgressBar()}
                ${this.getControls(seekTime, options)}
            </div>
            `; 
        this.audioPlayer = new Plyr(audioPlyrId, { seekTime, controls });

        const forwardButton = document.getElementById(options.forwardButtonId);
        const rewindButton = document.getElementById(options.rewindButtonId);
        const playPauseAudioButton = document.getElementById(options.playPauseButtonId);
        rewindButton.classList.add("disabled");

        forwardButton.addEventListener("click", () => {
            if(!forwardButton.classList.contains('disabled')) {
                this.audioPlayer.forward(seekTime);
            }
        });
        
        rewindButton.addEventListener("click", () => {
            if(!rewindButton.classList.contains('disabled')) {
                this.audioPlayer.rewind(seekTime);
            }
        });

        this.audioPlayer.on('timeupdate', () => {
            // Rewind button handling
            if(this.audioPlayer.currentTime == 0) {
                rewindButton.classList.add("disabled");
            } else {
                rewindButton.classList.remove("disabled");                
            }
            // forward button handling
            if(this.audioPlayer.currentTime == this.audioPlayer.duration) {
                forwardButton.classList.add("disabled");
            } else {
                forwardButton.classList.remove("disabled");                
            }
        });

        this.audioPlayer.on('play', () => {
            this.audioPromptPlayEvent.next();
            playPauseAudioButton.setAttribute('title', this.translationTexts.PAUSE);
            playPauseAudioButton.setAttribute('aria-label', this.translationTexts.PAUSE);
        });

        this.audioPlayer.on('pause', () => {
            playPauseAudioButton.setAttribute('title', this.translationTexts.PLAY);
            playPauseAudioButton.setAttribute('aria-label', this.translationTexts.PLAY);
        });
    }

    private getProgressBar() {
        return ` 
        <div class="prgrs">
            <div class="plyr__time plyr__time--current">00:00</div> 
                <div class="plyr__progress">
                    <input qid="aud-1" style="" data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="${this.translationTexts.PROGRESS_BAR}">
                    <span role="tooltip" class="plyr__tooltip">00:00</span> 
                </div>
            <div class="plyr__time plyr__time--duration">00:00</div> 
        </div> 
        `
    }

    private getControls(seekTime, options) {
        return `
        <div class="ctrls-main">
            <div class="ctrls">
                <button qid="${options.rewindButtonId}" type="button" class="plyr__control backwardSeek" id="${options.rewindButtonId}" aria-label="${this.translationTexts.REWIND}" title="${this.translationTexts.REWIND}">
                    <i class="nemo-font nemo-refresh" aria-hidden="true"></i>
                    <span class="seekText textinrew">-${seekTime}s</span>
                </button>
                <button qid="${options.playPauseButtonId}" type="button" class="plyr__control playpause" aria-label="${this.translationTexts.PLAY}" title="${this.translationTexts.PLAY}" data-plyr="play" id="${options.playPauseButtonId}"> 
                    <div class="icon--pressed"><span class="pause"><i class="fa fa-pause" aria-hidden="true"></i></span></div>
                    <div class="icon--not-pressed"><span class="play"><i class="fa fa-play" aria-hidden="true"></i></span></div>
                </button>
                <button qid="${options.forwardButtonId}" type="button" class="plyr__control forwardSeek" id="${options.forwardButtonId}" aria-label="${this.translationTexts.FORWARD}" title="${this.translationTexts.FORWARD}"> 
                    <i class="nemo-font nemo-refresh" aria-hidden="true"></i>
                    <span class="seekText textinfwd">+${seekTime}s</span>
                </button>
            </div>
        </div>
    `
    }

    public pauseAudioPromptPlayer() {
        if (this.audioPlayer && this.audioPlayer.playing) {
            this.audioPlayer.pause();
        }
    }

    public destroyPlayer() {
        if (this.audioPlayer) {
            this.audioPlayer.destroy();
        }
    }
}
